(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SocialMediaDeleteController',SocialMediaDeleteController);

    SocialMediaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SocialMedia'];

    function SocialMediaDeleteController($uibModalInstance, entity, SocialMedia) {
        var vm = this;

        vm.socialMedia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SocialMedia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
